/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveySubmissionWithCode = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        formId: {
    type: 'number',
    isRequired: true,
},
        code: {
    type: 'string',
},
        submittedDate: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        surveyData: {
    type: 'array',
    contains: {
        type: 'StaffSurveyResponseData',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        updatedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};